module.exports = __webpack_public_path__ + "img/年度盛典-1@2x.cd03e621.png";